import React from 'react';
import PropTypes from 'prop-types';

import { useSelector } from 'react-redux';
// Utils
import { dateGenerator } from 'utils/DateUtils';
import _get from 'lodash/get';
import styles from './style.cssmodule.css';

function formatDateAndTime(date) {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const year = String(date.getFullYear()).slice(-2); // Get last two digits of the year
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  const formattedDate = `${day}/${month}/${year}`;
  const formattedTime = `${hours}:${minutes}`;

  return { formattedDate, formattedTime };
}

const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

function DateParking({ dateString, timezone = browserTimezone, withTime }) {
  if (typeof dateString !== 'string' || !timezone) return <div className={styles.container}>—</div>;

  const date = dateGenerator.dateFromTimezone(dateString, timezone);
  const { formattedDate, formattedTime } = formatDateAndTime(date);

  return (
    <div className={styles.container}>
      <span className={styles.date} style={{ fontWeight: withTime ? '700' : '400' }}>
        {formattedDate}
      </span>
      {withTime
        ? (
          <span data-type="time">
            {' '}
            -
            {' '}
            <span className={styles.time}>
              {formattedTime}
            </span>
          </span>
        )
        : null}
    </div>
  );
}

DateParking.propTypes = {
  dateString: PropTypes.string,
  timezone: PropTypes.string,
  withTime: PropTypes.bool,
};
DateParking.defaultProps = {
  dateString: null,
  timezone: null,
  withTime: true,
};

export default DateParking;



// WEBPACK FOOTER //
// ./routes/cpm/routes/parkings/components/DateParking/DateParking.jsx